import { render, staticRenderFns } from "./CmgLeaderboardCyoRewardModal.vue?vue&type=template&id=4613b0fb&scoped=true&lang=pug"
import script from "./cmg-leaderboard-cyo-reward-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-cyo-reward-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardCyoRewardModal.vue?vue&type=style&index=0&id=4613b0fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613b0fb",
  null
  
)

export default component.exports